import { Card, Typography, Stack } from '@cast/design-system';
import { CloudVolume } from '@cast/types-stop';
import { convertUnit, dashesOrNum } from '@cast/utils';

import { CopyToClipboard } from 'components/clickable-actions';

type MetaItemProps = {
  label: string;
  value?: string | null;
  copyValue?: string;
  testId?: string;
};

const MetaItem = ({ label, value, copyValue, testId }: MetaItemProps) => (
  <Stack direction="row" gap={4} alignItems="center">
    <Typography variant="L10R" color="textSecondary">
      {label}:
    </Typography>
    <Typography variant="L10M" data-testid={testId}>
      {value}
    </Typography>
    {copyValue && (
      <CopyToClipboard
        text={copyValue}
        iconSize="13px"
        color="grey.400"
        tooltip="Copy to clipboard"
      />
    )}
  </Stack>
);

type ManagedDiskMetaCardProps = {
  disk: CloudVolume;
};

export const ManagedDiskMetaCard = ({ disk }: ManagedDiskMetaCardProps) => (
  <Card
    testId="managed-disk-meta-card"
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      px: 16,
      py: 12,
      justifyContent: 'space-between',
    }}
  >
    <MetaItem
      label="VOLUME ID"
      value={disk.volumeId ?? '—'}
      copyValue={disk.volumeId ?? undefined}
      testId="meta-volume-id"
    />
    <MetaItem label="TYPE" value={disk.volumeType ?? '—'} testId="meta-type" />
    <MetaItem
      label="CAPACITY"
      value={`${dashesOrNum({
        value: convertUnit(Number(disk.sizeBytes), 'Bytes', 'GiB'),
        roundBy: 1,
      })} GiB`}
      testId="meta-capacity"
    />
    <MetaItem label="ZONE" value={disk.zone ?? '—'} testId="meta-zone" />
  </Card>
);
